import { useQuery } from "@tanstack/react-query";
import { rankingApi } from "@bw/shared/api";
export function useMatchHistory(
  params: NonNullable<Parameters<typeof rankingApi.listMatches>[0]> = {},
) {
  return useQuery({
    queryKey: ["compete", "history", params],
    queryFn: () => rankingApi.listMatches(params),
  });
}
